import { atom } from 'jotai';

const authenticatedAtom = atom(false);

export default authenticatedAtom;